module.exports = __webpack_public_path__ + "img/bg-2.226e22c2.jpg";